import { MyPoint } from "../../../typescript/MyPoint";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { ColorPalette } from "./ColorPalette";

export class PaletteElement extends Phaser.GameObjects.Container {

    public currentScene: Phaser.Scene; 

    private colorClosed: boolean; 
    private backgroundImage: Phaser.GameObjects.Graphics; 
    private overlayTickImage: Phaser.GameObjects.Image; 
    private overlayNumber: Phaser.GameObjects.Text; 
    private parentPalette: ColorPalette; 

    constructor (scene: Phaser.Scene, parentPalette: ColorPalette, elmPos: MyPoint, elmColor: Phaser.Display.Color, elmID: number, elmSize: number = GameConstants.GAME_WIDTH / 6) {
        
        super(scene); 

        this.currentScene = scene; 
        this.parentPalette = parentPalette; 

        this.colorClosed = false; 

        // Create background image 
        this.backgroundImage = new Phaser.GameObjects.Graphics(scene); 
        this.backgroundImage.fillStyle(elmColor.color);                
        this.backgroundImage.fillRect(0, 0, elmSize, elmSize);
        this.backgroundImage.setInteractive(new Phaser.Geom.Rectangle(0, 0, elmSize, elmSize), 
        Phaser.Geom.Rectangle.Contains);
        this.backgroundImage.fillPath(); 
        this.add(this.backgroundImage);

        // Create overlay tick 
        this.overlayTickImage = this.scene.add.image(0, 0, "texture_atlas_1", "TickBlack.png"); 
        this.overlayTickImage.setDisplaySize(elmSize, elmSize); 
        this.overlayTickImage.setOrigin(0); 
        this.overlayTickImage.visible = false; 
        this.add(this.overlayTickImage); 

        // Add text color ID 
        this.overlayNumber = this.scene.add.text(elmSize / 2, elmSize / 2, elmID.toString(), {   
            fontFamily: "FredokaOne",
            fontSize: 50,
            color: "black"}); 

        if (elmColor.red + elmColor.green + elmColor.blue < 140) {
            this.overlayNumber.setColor("rgb(255, 255, 255)"); 
        }

        this.overlayNumber.setOrigin(0.5); 
        
        this.add(this.overlayNumber); 

        // Create Palette color callbacks         
        this.backgroundImage.setInteractive(); 
        this.backgroundImage.on("pointerup", function() {
                this.parentPalette.setSelectedID(elmID); 
        }, this);
    
        this.backgroundImage.on("pointerover", function() {
            GameVars.mouseInPalette = true; 
        }, this); 

        this.backgroundImage.on("pointerout", function() {
            GameVars.mouseInPalette = false; 
        }, this); 

        this.x = elmPos.x; 
        this.y = elmPos.y; 
    }

    public isColorClosed(): boolean {

        return this.colorClosed; 
    }

    public setClosed(close: boolean): void {

        if (close) {
            this.overlayNumber.visible = false; 
            this.overlayTickImage.visible = true; 
            this.colorClosed = true; 
        } else {
            this.overlayNumber.visible = true; 
            this.overlayTickImage.visible = false; 
            this.colorClosed = false; 
        }
    }
}

